/**
 * @ngdoc component
 * @name common.product.component:ItxProductSizes
 * @description
 * Show sizes  to choose.
*/
(function (itxApp) {

    'use strict';

    var ItxProductSizesCmp = {
        bindings: {
            product: '<',
            color: '<',
            onSizeAddedToCart: '&',
            onSizeSelected: '&',
            addQuickly: '<'
        },
        controller: ItxProductSizesCmpCtrl,
        templateUrl: 'product-sizes.component.html'
    };

    ItxProductSizesCmpCtrl.$inject = [
        '$timeout',
        'ngDialog',
        'imProductService',
        'ItxSizeGuideSvc',
        'ItxUtilsFct',
        'ItxConstants'
    ];

    function ItxProductSizesCmpCtrl(
        $timeout, 
        ngDialog, 
        imProductService, 
        ItxSizeGuideSvc,
        ItxUtilsFct,
        ItxConstants
    ) {

        var _this = this;
        _this.addQuickly = false;

        _this.$onInit = function () {
            _this.isOpenForSale = joyr.catalog.utils.isOpenForSale.bind(inditex);   
            
            if(_this.product.state.selectedSize){
                _this.selectedSize = _this.product.state.selectedSize;
            }
            
            //_this.size_icon = ItxStaticResourceSvc.getImage('size_dark-gray.png');
        };

        _this.$onChanges = function(){
            _this.sizes = _this.getSizes();
            _this.outOfStock = _this.product.activeDetail.colors.length && _this.sizes.length === 0;
        }

        //Memoize store the cache of the results based on the key provided by the second argument
        _this.getSizes = function () {
            _this.uniqueSize = false;
            var sizes;
            if (_this.product && _this.product.activeDetail.colors && _this.product.activeDetail.colors.length) {
                sizes = ItxSizeGuideSvc.removeDuplicates(_this.product.activeDetail.colors[_this.product.state.selectedColorIndex].sizes);

                if (sizes.length === 1 && sizes[0].name === '01') {
                    _this.uniqueSize = true;

                    if(!_this.addQuickly){
                        _this.selectedSize = sizes[0];
                        _this.product.selectSize(_this.selectedSize);
                    }
                    
                }

                if (_this.inChunks) {
                    return _.chunk(sizes, Math.round(sizes.length / 2));
                } else {
                    return sizes;
                }
            }
            return [];
        };
        
        _this.getComingSoon=function(size){
            return (_this.isBackOrCommingSoonSize(size) && _this.isOpenForSale());
        }
       
        _this.selectSize = function (size) {
            if ((size.visibility === 'disabled' || size.visibility === 'hidden') && _this.isOpenForSale()) {
                return;
            }

            if ((size.visibility === 'coming_soon' || size.visibility === 'back_soon') && _this.isOpenForSale()){
                _this.selectedSize = null;
                _this.goToStockAvailability(size);
                imProductService.eventSelectSize(_this.product, size, _this.product.state.selectedColorIndex);
                return;
            }
            _this.selectedSize = size;

            // IMAnalytics - when click size product on product file
            imProductService.eventSelectSize(_this.product, size, _this.product.state.selectedColorIndex);
            
            if(_this.onSizeSelected){
                _this.product.selectSize(size);
                _this.onSizeSelected({size: _this.selectedSize});
            }

            // Manda las analíticas también a Hero
            imProductService.sendProductViewToHero(_this.product);

        };

        _this.preSelectSize = function (size) {
            if ((size.visibility === 'disabled' && _this.isOpenForSale()) || (size.visibility === 'hidden' && _this.isOpenForSale()) ) {
                return;
            }

            /*
             *   IMAnalytics - when click size product on product file
             */
            if (!_this.preSelectedSize || size.name !== _this.preSelectedSize.name) {
                imProductService.eventSelectSize(_this.product, size, _this.product.state.selectedColorIndex);
            }

            _this.preSelectedSize = size;
            _this.selectedSize = size;
            
        };

        _this.goToStockAvailability = function (size) {
            var dialog = ngDialog.open({
                template: '<itx-product-stock-availability data="ngDialogData" on-close-dialog="ngDialogData.closeDialog()"></itx-product-stock-availability>',
                className: 'new-modal hg-modal-md hg ma-dialog ma-dialog-full stock-notification ngdialog-theme-plain',
                plain: true,
                showClose: true,
                data: {product: _this.product, selectedSize: size,
                    closeDialog: function(){ 
                        dialog.close();
                    }
                }
            });
        };

        _this.isBackOrCommingSoonSize = function (size) {
            return _this.isBackSoonSize(size) || _this.isCommingSoonSize(size);
        };

        _this.isBackSoonSize = function (size) {
            if (!size.visibility) {
                return false;
            }
            return size.visibility.toLowerCase() === 'back_soon';
        };

        _this.isCommingSoonSize = function (size) {
            if (!size.visibility) {
                return false;
            }
            return size.visibility.toLowerCase() === 'coming_soon';
        };

        _this.openSizeAssistant = function () {
            $timeout(function(){$(".fitanalytics__button-text").click()});
        }

        _this.openSizeGuide = function () {
            $timeout(function(){$(".size-guide").click();});
        }

        _this.hasDisabled = size => {
            return (size.visibility === 'disabled' || size.visibility === 'hidden');
        }
        
        _this.hasSelected = size => {
            if(_this.selectedSize){
                return _this.selectedSize.sku === size.sku;
            } else {
                return false;
            }
        }

    }

    angular.module('itxApp.common')
        .component('itxProductSizes', ItxProductSizesCmp);
})();
